export const getBigAmount = amount => new Intl.NumberFormat('en', {
  style: 'decimal',
}).format(amount / 100);

export const formatMoney = ({ amount, currency }) => {
  const bigAmount = getBigAmount(amount);
  return `${currency} ${bigAmount}`;
};

export const CURRENCY_NAMES = {
  NGN: 'Naira',
  USD: 'Dollars',
  GBP: 'Pounds',
};
